exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".metric-description{padding-right:10px}.metrics-card-text{height:70%}.metrics-card-top{min-height:300px;display:inline-block;width:100%}.metrics-card-middle-bottom{height:200px;display:inline-block;width:100%}.hidden-element{visibility:hidden;height:24px;width:24px}", ""]);

// exports
